import useConnectWallet from "@/store/wallet/useConnectWallet";
import { useState } from "react";
import { toast } from "react-toastify";

const useRegister = () => {
  // 获取合约
  const {
    contractEvm: { RegularStaking },
  } = useConnectWallet();
  // laoding
  const [registerLod, setLoading] = useState(false);
  // 注册函数
  const register = async (
    referral: string,
    toastText: { success: string; error: string },
    suuFun?: () => void,
    errFun?: () => void
  ) => {
    if (RegularStaking) {
      setLoading(true);
      try {
        const tx = await RegularStaking.register(referral);
        await tx.wait();
        toast.success(toastText.success);
        suuFun && suuFun();
      } catch (e) {
        console.log("useRegister", e);
        errFun && errFun();
        toast.error(toastText.error);
      } finally {
        setLoading(false);
      }
    }
  };
  return { register, registerLod };
};

export default useRegister;
